<template>
    <div class="pb-10">
        <div class="subtitle-2 py-5">Sportanlage</div>
        <info-line v-for="(sportanlageRow, i) in sportanlageRows" :key="i" :header="sportanlageRow.label">
            {{getValueOrPlaceholder(vereinsdatenblatt.sportanlage[sportanlageRow.field])}}
        </info-line>
        <v-divider></v-divider>
        <div v-for="(person) in persons" :key="person.label">
            <div class="subtitle-2 py-5">{{personLabels[person]}}</div>
            <info-line v-for="(personRow, i) in personRows" :key="i" :header="personRow.label">
                {{getValueOrPlaceholder(vereinsdatenblatt[person][personRow.field])}}
            </info-line>
            <v-divider></v-divider>
        </div>
        <div class="subtitle-2 py-5">Team</div>
        <info-line v-for="(teamRow) in teamRows" :key="teamRow.label" :header="teamRow.label">
            {{getValueOrPlaceholder(vereinsdatenblatt.trainerTeam[teamRow.field])}}
        </info-line>
        <div>
            <v-divider></v-divider>
            <div v-for="(sportkapitaen, j) in vereinsdatenblatt.sportkapitaene" :key="j">
                <div class="subtitle-2 py-5">Sportkapitän/in</div>
                <info-line header="Zuständig für Liga/Mannschaft">
                    {{getValueOrPlaceholder(sportkapitaen.team)}}
                </info-line>
                <info-line v-for="(personRow) in personRows" :key="personRow.label" :header="personRow.label">
                    {{getValueOrPlaceholder(sportkapitaen[personRow.field])}}
                </info-line>
            </div>
        </div>
        <v-btn v-if="$vuetify.breakpoint.smAndDown" fab dark bottom right
               color="primary" style="position: fixed; right: 15px; bottom: 15px; z-index: 15" @click="back()">
            <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
    </div>
</template>

<script>
    import InfoLine from "../../../components/elements/infoLine";

    export default {
        components: {InfoLine},
        name: "vereinsdatenblatt-team-mob",
        props: ['vereinsdatenblatt', 'persons', 'personRows', 'sportanlageRows', 'teamRows'],
        data: () => ({
            personLabels: {obmann: 'Obmann/Obfrau', sektionsleiter: 'Sektionsleiter/in', sportkapitaen: 'Sportkapitän/in'}
        }),
        methods: {
            getValueOrPlaceholder(value){
                return value ? value : '-'
            },
            back(){
                window.history.back();
            }
        },
    }
</script>

<style scoped>

</style>